import { render } from "./InformationPanelRenderWord.component.vue?vue&type=template&id=3eb41a80&scoped=true"
import script from "./InformationPanelRenderWord.component.vue?vue&type=script&lang=js"
export * from "./InformationPanelRenderWord.component.vue?vue&type=script&lang=js"

import "./InformationPanelRenderWord.component.vue?vue&type=style&index=0&id=3eb41a80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb41a80"]])

export default __exports__